module.exports = __webpack_public_path__ + "static/media/arrow-white.3001856b.svg";